/**
 * DrManiProgressBar - quiz progress indicator for the Dr. Mani quiz.
 *
 * DMM-native counterpart to CitrusQuiz/ProgressBar. Uses the dmm-progress-*
 * classes from DrManiQuiz.css (no citrus-* / progress-bar-* class names) so the
 * Dr. Mani quiz stays decoupled from the USCN CSS naming convention.
 */
import React from 'react';

type BarType = 'full' | 'text';

interface DrManiProgressBarProps {
  current: number;
  total: number;
  bartype?: BarType;
}

const DrManiProgressBar: React.FC<DrManiProgressBarProps> = ({
  current,
  total,
  bartype = 'full',
}) => {
  const percentage = Math.min((current / total) * 100, 100);

  return bartype === 'text' ? (
    <span className="dmm-progress-status">Question {current} of {total}</span>
  ) : (
    <div className="dmm-progress-bar-container">
      <div className="dmm-progress-bar">
        <div className="dmm-progress-bar-fill" style={{ width: `${percentage}%` }} />
      </div>
      <span className="dmm-progress-text">Question {current} of {total}</span>
    </div>
  );
};

export default DrManiProgressBar;
